import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { PriceAdjustmentType } from "../../constants/priceAdjustmentType"
import { IsNumber, IsPositive } from "class-validator"

@Serializable
export class PriceAdjustmentArgs {
  taskId: string = ""
  comment: string = ""
  @IsPositive({
    message: '$t(form.errors.greater, {"count": 0 })',
    groups: ["create_adjustment"],
  })
  @IsNumber(
    { allowNaN: false, allowInfinity: false },
    {
      message: "form.errors.number",
      groups: ["create_adjustment"],
    },
  )
  adjustmentAmount: number = 0
  adjustmentType: PriceAdjustmentType = PriceAdjustmentType.Undefined

  constructor(
    data: {
      taskId: string
      comment: string
      adjustmentAmount: number
      adjustmentType: number
    } | null = null,
  ) {
    if (data) {
      this.taskId = data.taskId
      this.comment = data.comment
      this.adjustmentAmount = data.adjustmentAmount
      this.adjustmentType = data.adjustmentType
    }
  }
}
